var _clipPath, _clipPath2, _clipPath3, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVndMsPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-95.3204,-1169.86)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,284.888L27,383.888L99,383.888L99,311.888L72,284.888L27,284.888Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,383.888L27,284.888L99,284.888L99,383.888L27,383.888Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,284.889L99,311.889L99,383.889L27,383.889L27,284.889L72,284.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(193,81,39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.52,305.901L44.52,308.186C44.969,308.244 45.648,308.367 46.556,308.552C47.464,308.737 48.191,308.947 48.738,309.182C49.519,309.514 50.027,309.928 50.26,310.426C50.495,310.924 50.612,311.515 50.612,312.198L50.612,341.512C50.612,342.313 50.49,342.937 50.246,343.387C50.002,343.836 49.499,344.217 48.738,344.529C48.366,344.684 47.713,344.817 46.776,344.924C45.839,345.032 45.087,345.115 44.52,345.173L44.52,347.457L67.041,347.457L67.041,345.173C66.435,345.115 65.694,344.997 64.815,344.821C63.937,344.646 63.301,344.481 62.912,344.323C62.17,344.012 61.667,343.597 61.403,343.079C61.14,342.561 61.007,341.951 61.007,341.249L61.007,329.563L64.405,329.563C67.217,329.563 69.75,329.32 72.005,328.832C74.26,328.344 76.266,327.554 78.023,326.46C79.722,325.405 81.054,324.034 82.021,322.345C82.986,320.656 83.47,318.641 83.47,316.298C83.47,312.783 82.141,310.173 79.487,308.464C76.832,306.756 72.819,305.901 67.451,305.901L44.52,305.901ZM61.007,308.566L63.438,308.566C66.66,308.566 68.9,309.323 70.16,310.836C71.419,312.35 72.049,314.668 72.049,317.791C72.049,320.857 71.214,323.126 69.545,324.6C67.876,326.074 65.44,326.811 62.239,326.811L61.007,326.811L61.007,308.566Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.742,326.679L61.194,289.227L93.233,321.265L55.781,358.718L23.742,326.679Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,311.888L99,311.888L72,284.888L72,311.888Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5,298.388L72,284.888L99,311.888L85.5,325.388L58.5,298.388Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,284.889L99,311.889L72,311.889L72,284.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(193,81,39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "36px",
    y: "375.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "white"
    }
  }, "P", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "53.976px 71.952px ",
    y: "375.889px 375.889px "
  }, "PT"))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-99,99,-4.3e-06,63,383.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(204,86,39)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247,149,34)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(37.1306,-37.1306,37.1306,37.1306,39.7622,342.699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(215,92,37)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(179,75,32)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.4999,-13.4999,13.4999,13.4999,72,311.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(254,252,227)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(249,220,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    style: {
      stopColor: "rgb(235,160,101)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(224,111,38)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVndMsPowerpoint);
export default __webpack_public_path__ + "static/media/vnd-ms-powerpoint.be4650ae94963d26e3a5f643898f80f7.svg";
export { ForwardRef as ReactComponent };